"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefault = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var noop_1 = require("./noop");
function useDefault(value, defaultValue, onChange) {
    var isControlledRef = (0, react_1.useRef)(false);
    var _a = (0, tslib_1.__read)((0, react_1.useState)(defaultValue), 2), internalValue = _a[0], setInternalValue = _a[1];
    // 受控模式
    if (isControlledRef.current || typeof value !== 'undefined') {
        isControlledRef.current = true;
        return [value, onChange || noop_1.noop];
    }
    // 非受控模式
    return [
        internalValue,
        function (newValue) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            setInternalValue(newValue);
            if (typeof onChange === 'function') {
                onChange.apply(void 0, (0, tslib_1.__spreadArray)([newValue], (0, tslib_1.__read)(args), false));
            }
        },
    ];
}
exports.useDefault = useDefault;
